module.exports = __webpack_public_path__ + "static/media/no_document.bacff000.png";